export default {
  // task-eva-components
  "--task-eva-text-color-1": "#E0EDEF",
  "--task-eva-drawer-color-bg-mask": "rgba(0, 0, 0, 0.45)",
  "--task-eva-drawer-color-bg-header": "#18191B",
  "--task-eva-drawer-title-color": "#E0EDEF",
  "--task-eva-drawer-box-shadow-right":
    "-6px 0 16px 0 rgba(0, 0, 0, 0.08), -3px 0 6px -4px rgba(0, 0, 0, 0.12),-9px 0 28px 8px rgba(0, 0, 0, 0.05)",
  "--task-eva-drawer-box-shadow-left":
    "6px 0 16px 0 rgba(0, 0, 0, 0.08), 3px 0 6px -4px rgba(0, 0, 0, 0.12), 9px 0 28px 8px rgba(0, 0, 0, 0.05)",
  "--task-eva-drawer-box-shadow-top":
    "0 6px 16px 0 rgba(0, 0, 0, 0.08), 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05)",
  "--task-eva-drawer-box-shadow-bottom":
    "0 -6px 16px 0 rgba(0, 0, 0, 0.08), 0 -3px 6px -4px rgba(0, 0, 0, 0.12), 0 -9px 28px 8px rgba(0, 0, 0, 0.05)",
  "--task-eva-drawer-drag-button-bg": "#45484D",
  // new
  "--color-coupon": "#963C0B",
  "--color-coupon-sub": "#BE4C0E",
  "--color-coupon-tab-bg":
    "linear-gradient(98.16deg, #FC7032 2.09%, #FCB732 98.11%)",
  "--color-coupon-content-bg": "#FDEDD6",
  "--color-coupon-content-title": "#DE7238",
  "--color-coupon-content": "#BE4C0E",
  "--color-coupon-border": "#F5CEB8",
  "--color-coupon-button": "#F3512B",
  "--color-coupon-button-bg":
    "linear-gradient(118.85deg, #F2603E 8.04%, #F38B2B 97.41%)",
  "--topup-member-card-bg": "#212327",
  "--topup-recharge-input": "#333336",
  "--topup-recharge-input-border": "#495359",
  "--background-input-2c2c31": "#2c2c31",
  "--background-input-191D1F": "#191D1F",
  "--antd-modal-header": "#444546",
  "--antd-drawer-header": "#333336",
  "--antd-drawer-header-border": "#43454d",
  // task-eva
  "--task-button-common-color": "#EE5B5B",
  "--task-text-color": "#FC7032",
  "--task-link-color": "#F3512B",
  "--task-btn-outline-bg": "#343538",
  "--task-user-icon-background":
    "linear-gradient(118.85deg, #F2603E 8.04%, #F38B2B 97.41%)",
  "--task-primary-button-bg":
    "linear-gradient(118.85deg, #F2603E 8.04%, #F38B2B 97.41%)",
  "--task-primary-button-bg-hover":
    "linear-gradient(118.85deg, #FF912C 8.04%, #FF5229 97.41%)",
  "--task-primary-button-bg-disable": "#DFA68D",
  "--task-primary-button-color-disable": "#E8F4F6",
  "--task-platform-full": "#DF3535",
  "--task-button-link-hover": "#242529",
  "--task-button-outline-hover": "#242529",
  "--task-button-outline-disable": "#DFA68D",
  "--task-button-outline-disable-border": "#DFA68D",
  // migu in task-eva
  "--task-eva-color": "#D9DFE0",
  "--task-eva-sidebar": "#343538",
  "--task-eva-sidebar-color": "#9BA2B0",
  "--task-eva-sidebar-color-active": "#D9DFE0",
  "--task-eva-sidebar-item": "#26282C",
  "--task-eva-sidebar-item-gap": "#45464b",
  "--task-eva-header": "#262729",
  "--task-eva-header-color": "#FFFFFF",
  "--task-eva-header-color": "#9BA2B0",
  "--task-eva-header-color-active": "#D9DFE0",
  "--task-eva-header-shadow": "0px 4px 10px rgba(1, 8, 12, 0.6)",
  "--task-eva-platform-select-color": "#384248",
  "--task-eva-platform-select-bg": "#343538",
  "--task-eva-platform-select-bg-active": "#18191D",
  "--task-eva-platform-select-item-color": "#D9DFE0",
  "--task-eva-platform-select-item-hover": "#17181c",
  "--task-eva-platform-select-title-gap": "#515356",
  "--task-eva-select-arrow": "#525358",
  "--task-eva-dropdown-content-bg": "#343538",
  "--task-eva-dropdown-content-border": "#515356",
  "--task-eva-dropdown-content-shadow": "0px 4px 20px rgba(0, 0, 0, 0.66)",
  "--task-eva-content-bg": "#0f1010",
  "--task-eva-toptip-bg": "#000",
  "--task-eva-toptip": "#bfc2c3",
  "--task-eva-common-card-bg": "#292b2f",
  "--task-eva-common-card-border": "#343538",
  "--task-eva-common-inner-card-border": "#343538",
  "--task-eva-statistic-card-title": "#bfc2c3",
  "--task-eva-statistic-card-success": "#13CB75",
  "--task-eva-statistic-card-default": "#D9DFE0",
  "--task-eva-statistic-card-fail": "#DF3535",
  "--task-eva-pie-total": "#636770",
  "--task-eva-pie-linear-0": "#13CB75",
  "--task-eva-pie-linear-1": "#13CB9F",
  "--task-eva-pie-left": "#43464e",
  "--task-eva-line-chart-line": "#404246",
  "--task-eva-search-bg": "#343538",
  "--task-eva-search-color": "#FFFFFF",
  "--task-eva-search-placeholder": "#5C6569",
  "--task-eva-search-border-focus": "#FC7032",
  "--task-eva-search-border": "transparent",
  "--task-eva-modal-bg": "#292b2f",
  "--task-eva-modal-border": "#343538",
  "--task-eva-modal-close-icon": "#D4D4D4",
  "--task-eva-platform-modal-body-title": "#FFF",
  "--task-eva-storage-modal-header": "#17181c",
  "--task-eva-storage-modal-header-text": "#636770",
  "--task-eva-storage-modal-title-size": "14px",
  "--task-eva-storage-modal-body-text-size": "12px",
  "--task-eva-storage-modal-body-text": "#D9DFE0",
  "--task-eva-storage-modal-gap": "#343538",
  "--task-eva-storage-modal-title-border": "#343538",
  "--task-eva-tooltip-light-bg": "rgba(255, 255, 255, 0.1)",
  "--task-eva-tooltip-light-color": "rgb(0, 0, 0)",
  "--task-eva-tooltip-dark-bg": "rgba(0, 0, 0, 1)",
  "--task-eva-tooltip-dark-color": "rgb(255, 255, 255)",
  "--task-eva-filter-condition-border": "#505050",
  // user center
  "--color-red": "#FB6B4A",
  "--color-main-gradient": "#f97d60",
  "--color-main-alpha-26": "rgba(251, 107, 74, 0.26)",
  "--color-main-alpha-2": "rgba(251, 107, 74, 0.2)",
  "--color-main-alpha-1": "rgba(98, 126, 217, 0.1)",
  "--color-main-alpha-05": "rgba(251, 107, 74, 0.05)",
  "--color-main-alpha-08": "rgba(251, 107, 74, 0.08)",
  "--color-main-alpha-022": "rgba(251, 107, 74, 0.022)",
  "--color-invoice-button-disalbe": "#fc9982",
  "--color-datepicker-hover": "#fdad9b",
  "--color-main-help": "#627ED9",
  "--color-bill-tip-border": "1px solid rgba(98, 126, 217, 0.26)",
  // old
  "--content-background": "#333",
  "--main-background": "#222",
  "--background-normal": "#282828",
  "--fill-tree-active": "#454545",
  "--common-font-color": "#fff",
  "--color-green": "#13cb75",
  "--color-dark-green": "#263930",
  "--color-999": "#999",
  "--main-color": "var(--color-red)",
  "--main-color-btn-hover-center": "#FF912C",
  "--main-color-btn-active": "#DFA68D",
  "--main-color-btn-disable": "#DFA68D",
  "--main-color-btn-hover": "#fc8569",
  "--frames-color": "#9fde92",
  "--dialog-header-color": "#404040",
  "--dialog-title-color": "#fff",
  "--render-layer-label-color": "#999",
  "--header-icon-bg": "#666",
  "--header-icon-color": "#fff",
  "--platform-bg": "#3d5444",
  "--platform-color": "#13cb75",
  "--platform-list-color": "#eee",
  "--platform-dropdown-bg": "#3f4041",
  "--sidebar-hover-background": "#13cb75",
  "--sidebar-hover-color": "var(--common-font-color)",
  "--index-hover": "var(--color-green)",
  "--overview-text-color1": "#13cb75",
  "--overview-text-color2": "#f4f4f4",
  "--overview-text-color3": "#999",
  "--overview-border-color": "#444",
  "--overview-title": "#999",
  "--button-bg": "var(--color-green)",
  "--soft-bg": "var(--color-dark-green)",
  "--soft-side-bar-bg": "#282828",
  "--green-blue-match": "var(--color-green)",
  "--task-user-icon-background":
    "linear-gradient(118.85deg, #F2603E 8.04%, #F38B2B 97.41%)",
};
